(function () {
    "use strict";
    
    class ProductItemSizeSelector{
        constructor(root){
            this.root = root;
            // Check if .product-json-data exists
            const jsonDataElement = this.root.querySelector(".product-json-data");
            if (!jsonDataElement) {
                // Comment out so it doesn't float the console log
                // console.warn("Missing .product-json-data in product item:", root);
                return; // Exit constructor if JSON data is missing
            }
    
            // Convx 849: lazy. Keep the element, parse on first open. Parsing every
            // card's payload during page load cost one JSON.parse per card (38 on a
            // collection page, ~64 on the homepage) for a list most shoppers never open.
            this.jsonDataElement = jsonDataElement;
            this._json = null;
            this._rendered = false;
            this._pendingColor = null;

            // Prevent duplicate initialization
            if (this.root.querySelector(".select-dropdown-container")) {
                // Comment out so it doesn't float the console log
                // console.warn("ProductItemSizeSelector already initialized for:", root);
                return; // Exit if already initialized
            }

            // Attach event listeners to color swatches
            const colorSwatches = this.root.querySelectorAll(".color-swatch__radio"); // Adjust selector as needed
            colorSwatches.forEach(swatch => {
                swatch.addEventListener("change", this.onColorSwatchClick.bind(this));
            }); 

            const productItem = this.root.querySelector(".product-item__info");

            // New dropdown HTML
            const dropdownContainer = document.createElement("div");
            dropdownContainer.className = "select-dropdown-container";
            productItem.parentNode.insertBefore(dropdownContainer, productItem.nextSibling); // This is to append right after product-item__info class of each card

            this.placeholderName = document.createElement("div");
            this.placeholderName.className = "expandable-toggle";

            this.placeholderName.innerHTML = `
                <span class="heading">Quick Add</span>
                <div class="placeholder-expand"><svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1em;height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M0 0h1024v1024H0z" fill="#333333" opacity=".01"/><path d="M512 51.2a51.2 51.2 0 0 1 51.2 51.2v358.4h358.4a51.2 51.2 0 0 1 0 102.4h-358.4v358.4a51.2 51.2 0 0 1-102.4 0v-358.4H102.4a51.2 51.2 0 0 1 0-102.4h358.4V102.4a51.2 51.2 0 0 1 51.2-51.2z" fill="#333333"/></svg> </div>
                <div class="placeholder-collapse" style="display: none;"><svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 1em;height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M0 0h1024v1024H0z" fill="#333333" opacity=".01"/><path d="M51.2 460.8m51.2 0l819.2 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-819.2 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z" fill="#333333"/></svg> </div>
            `;
            dropdownContainer.appendChild(this.placeholderName);          


            const sizeContainer = document.createElement("div");
            sizeContainer.className = "size-container";
            dropdownContainer.appendChild(sizeContainer); 

            // Toggle size-container visibility on placeholder click
            this.placeholderName.addEventListener("click", (event) => {
                event.stopPropagation(); // Prevent click even from bubbling up
                const newSizeContainer = this.root.querySelector(".size-container")
                const isVisible = newSizeContainer.style.display === "block";

                // Convx 849: build the size list the first time this card is opened.
                if (!isVisible && !this._rendered) {
                    this.renderSizeDropdown(this._pendingColor);
                    this._rendered = true;
                }

                newSizeContainer.style.display = isVisible ? "none" : "block"; // Toggle display

                // Toggle visibility of expand/collapse elements
                this.placeholderName.querySelector(".placeholder-expand").style.display = isVisible ? "block" : "none";
                this.placeholderName.querySelector(".placeholder-collapse").style.display = isVisible ? "none" : "block";
            });

            // Convx 849: was renderSizeDropdown(swatch.value) here, which built the full
            // size list for every card during page load and then hid it. Now we only note
            // which colourway is selected; the list is built on first open.
            colorSwatches.forEach(swatch => {
                if (swatch.checked) {
                    this._pendingColor = swatch.value;
                }
            })
            if (this._pendingColor === null && colorSwatches.length) {
                this._pendingColor = colorSwatches[0].value;
            }

        }

        // Convx 849: parsed on first use rather than at construction.
        get productJsonData() {
            if (!this._json) {
                this._json = JSON.parse(this.jsonDataElement.textContent);
            }
            return this._json;
        }

        onColorSwatchClick(event) {
            const clickedColor = event.target.value; // Assuming the color swatch has a value attribute
            this._pendingColor = clickedColor;
            // Only re-render if the shopper has already opened this card's size list.
            // If they have not, the colour is remembered and rendered when they do.
            if (this._rendered) {
                this.renderSizeDropdown(clickedColor);
            }
        }

        renderSizeDropdown(option1) {
            const newSizeContainer = this.root.querySelector(".size-container"); // Ensure this container exists in your HTML
            newSizeContainer.innerHTML = ''; // Clear previous dropdown

            const filteredVariants = this.productJsonData.variants.filter(variant => variant.option1 === option1);
            const option2Array = [...new Set(filteredVariants.map(variant => variant.option2))]; // Ensure unique sizes

            const buttonContainer = document.createElement("div");
            buttonContainer.className = "button-container";

            option2Array.forEach(option2 => {
                const variant = filteredVariants.find(v => v.option1 === option1 && v.option2 === option2);
                const optionElement = document.createElement("button");
                optionElement.textContent = option2;
                optionElement.value = variant.id; // Store variant ID as value
                optionElement.disabled = !variant.available; // Disable if not available

                optionElement.addEventListener("click", () => {
                    if (variant && variant.available) {
                        // Trigger add-to-cart logic here
                        let formData = {
                        'items': [{
                            'id': variant.id,
                            'quantity': 1
                            }]
                        };
                        fetch(window.Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                            'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formData)
                        })
                        .then(response => {
                            return response.json();
                        })
                        .then(responseJson => {
                            // return response.json();
                            fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
                                const cartContent = await response2.json();
                                document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                                  bubbles: true,
                                  detail: {
                                    cart: cartContent
                                  }
                                }));
                                cartContent["sections"] = responseJson["sections"];
                                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                                  bubbles: true,
                                  detail: {
                                    cart: cartContent,
                                    openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.root.closest(".drawer") === null
                                  }
                                }));
                                document.querySelector("cart-drawer").open = true;
                                window.cdpTrackingCode?.trackAddToCart(responseJson.items[0], this.root , cartContent);
                              });
                        })
                        
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                        console.log(`Adding ${variant.title} to cart`);
                    }
                });

                buttonContainer.appendChild(optionElement);
            });

            newSizeContainer.appendChild(buttonContainer);

        }
    }

    function function_() {
        const style = document.createElement("style");
        style.textContent = `
            /* Add any custom styles here */
            .product-item__quick-buy-button{
	            display: none;
            }
            
            .expandable-toggle {
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;
                font-weight: bold;
                margin-right: 8px;
            }

            .select-dropdown-container {
                border-radius: 5px;
                padding: 10px 5px;
                margin-top: 10px;
                width: 100%;
                box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
            }

            .size-container {
                display: none; /* Initially hidden */
                margin-top: 10px;
            }

            .button-container {
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 10px;
            }

            .button-container button {
                padding: 8px;
                font-size: 14px;
                border: 1px solid #ccc;
                border-radius: 5px;
                background-color: #fff;
                cursor: pointer;
                text-align: center;
                transition: background-color 0.3s;
            }

            .button-container button:hover {
                background-color: #f0f0f0;
            }

            .button-container button:disabled {
                background-color: #e0e0e0;
                cursor: not-allowed;
                opacity: 0.5;
            }
            .product-item__info{
                flex-grow: 0;
            }         

            @media only screen and (max-width: 768px ){
                .button-container {
                    grid-template-columns: repeat(4, 1fr);
                }

                .button-container button {
                    padding: 6px;
                    font-size: 12px;
                }
            }
        `;
        document.head.append(style);

        // const variants = JSON.parse(document.querySelector(".product-json-data").textContent).variants;
        const productItemInfo = document.querySelectorAll("#facet-main .product-item");
        const featuredProductItemInfo = document.querySelectorAll(".featured-collections .product-item");

        productItemInfo.forEach(productItem => {
            productItem.productItemSizeSelector = new ProductItemSizeSelector(productItem);
        });

        featuredProductItemInfo.forEach(featuredProductItem => {
            featuredProductItem.productItemSizeSelector = new ProductItemSizeSelector(featuredProductItem);
        });
      
        document.addEventListener("product-card-rendered", () => {
          const productItemInfo = document.querySelectorAll("#facet-main .product-item");
          
          productItemInfo.forEach(productItem => {
            if(!productItem.productItemSizeSelector){
                productItem.productItemSizeSelector = new ProductItemSizeSelector(productItem);
            }
          });
          
          const featuredProductItemInfo = document.querySelectorAll(".featured-collections .product-item");
          
          featuredProductItemInfo.forEach(featuredProductItem => {
            if (!featuredProductItem.productItemSizeSelector) {
                featuredProductItem.productItemSizeSelector = new ProductItemSizeSelector(featuredProductItem);
            }
          });
        })
    }
    
    function onDOMContentLoaded() {
        function_();
    }
    
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
            once: true,
        });
    } else {
        onDOMContentLoaded();
    }
})();